// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5643":"css/app.7071","8861":"css/admin-app.7071"}[chunkId] + ".css";
};